import ApiAttendance from "../../../gd/api/attendance";

export default async function deleteAttendance(id: ID){

    const app: any = gd.getApp()

    if(app.viewForUserId === gd.session.me.id){
        gd.modals.confirm.deleteByNameWithComment('Clock In / Out record', "", "", async ()=>{
            try {
                await ApiAttendance.deleteAttendance(id).promise()
                gd.session.setAttendanceStatus = undefined
                await gd.session.attendanceStatus()
                gd.modal.hide();
                await app.init()
                gd.bus.triggerEvent("attendance:update")
                app.reRender()
            }
            catch(e: any){
                console.error(e)
            }
        })
    }
    else{
        gd.modals.confirm.deleteByNameWithComment('Clock In / Out record', "", "", async ()=>{
            try {
                await ApiAttendance.deleteAttendance(id).promise()
                gd.modal.hide();
                await app.init()
                app.reRender()
            }
            catch(e: any){
                console.error(e)
            }
        })
    }
}
